import { ChartNoAxesCombined, Flame, Heart, Radar, Settings, SquareKanban, Wrench, type LucideIcon } from 'lucide-react'

export interface Section {
  path: string
  title: string
  /** Подпись во вкладке на телефоне. */
  short: string
  icon: LucideIcon
}

export const SECTIONS: Section[] = [
  { path: '/', title: 'Залёты', short: 'Залёты', icon: Flame },
  { path: '/favorites', title: 'Избранное', short: 'Избранное', icon: Heart },
  { path: '/tools', title: 'Инструменты', short: 'Инструменты', icon: Wrench },
  { path: '/sources', title: 'Источники', short: 'Источники', icon: Radar },
  { path: '/plan', title: 'Контент-план', short: 'План', icon: SquareKanban },
]

export const SETTINGS: Section = { path: '/settings', title: 'Настройки', short: 'Настройки', icon: Settings }
// В Mini App вход расположен в «Инструментах»: пять основных вкладок сохраняются.
export const ANALYTICS: Section = { path: '/analytics', title: 'Аналитика', short: 'Аналитика', icon: ChartNoAxesCombined }

export function isRootPath(pathname: string): boolean {
  return SECTIONS.some((s) => s.path === pathname)
}

export function titleFor(pathname: string): string {
  if (pathname.startsWith('/analytics/reels/')) return 'Статистика Reels'
  if (pathname === ANALYTICS.path) return 'Аналитика Instagram'
  if (pathname.startsWith('/sources/')) return 'Источник'
  if (pathname.startsWith('/post/')) return 'Пост'
  if (pathname.startsWith('/favorites/')) return 'Группа'
  if (pathname === '/tools/uniqueness') return 'Уникализация'
  return [...SECTIONS, SETTINGS].find((s) => s.path === pathname)?.title ?? 'Контент Завод'
}
